import { useContext, useState, useMemo } from 'react';
import { DisneyOneID } from '@/components/Membership/DisneyOneID';
import { AppContext } from "@/App";
import { getXssFilter } from '@showclix-shared-util/xssFilter';

const MembershipLoginView = ({ onMembershipLoginChange }) => {
  const { membershipConfig, embeddedCheckout, t } = useContext(AppContext);
  const [verificationSent, setVerificationSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const xssFilter = useMemo(() => getXssFilter(), []);

  return (
    <div className="member-login">
      {!errorMessage && (
        <>
          {verificationSent && (
            <div className="full-width text-center text-lg">
              {t('membership__verification_link_sent')}
            </div>)}
          {!verificationSent && (
            <>
              <div className="member-login__content">
                <h2 className="text-lg">{membershipConfig.title_text}</h2>
                <p className="text-md mt-0 mb-0">{membershipConfig.subtitle_text}</p>
                <p dangerouslySetInnerHTML={{__html: xssFilter.process(membershipConfig.additional_text)}}></p>
              </div>
              {membershipConfig.membershipType === 'DISNEY_ONEID' && (
                <DisneyOneID {...membershipConfig}
                             onMembershipLoginChange={onMembershipLoginChange}
                             onVerificationSent={() => setVerificationSent(true)}
                             onError={setErrorMessage}
                             embeddedCheckout={embeddedCheckout}/>
              )}
            </>
          )}
        </>
      )}
      {errorMessage && (
        <div className="full-width text-center text-lg"
             dangerouslySetInnerHTML={{__html: xssFilter.process(errorMessage)}}></div>
      )}
    </div>
  );
}

MembershipLoginView.propTypes = {}

export default MembershipLoginView;
